'use strict';

/* global window */
/* eslint
    no-underscore-dangle: off,
    no-var: off,
    prefer-rest-params: off,
    vars-on-top: off,
*/

var _assign = require('lodash/assign');

exports.trackEvent = _trackEvent;
exports.trackPageView = _trackPageView;
exports.setCustomDimensions = _setCustomDimensions;
exports.shouldDispatchToNative = shouldDispatchToNative;

function logError() {
    if (typeof window !== 'undefined' && window.console && window.console.error) {
        window.console.error.apply(console, arguments);
    }
}

// eslint-disable-next-line consistent-return
function _getMobNativeApi() {
    if (typeof window !== 'undefined' && window.ZMOB_nativeAPI) {
        return window.ZMOB_nativeAPI;
    }
}

var customDimensions = {};
function _setCustomDimensions(incomingCustomDimensions) {
    var coercedCustomDimensions = {};
    if (incomingCustomDimensions) {
        var keys = Object.keys(incomingCustomDimensions);
        // eslint-disable-next-line prefer-arrow-callback
        keys.forEach(function coerceDimension(element) {
            // remove dimension from the key
            // the iOS/Android client does not expect the leading qualifier in the string.
            // gross.
            var key = element.replace('dimension', '');
            coercedCustomDimensions[key] = incomingCustomDimensions[element];
        });
    }
    customDimensions = _assign(customDimensions, coercedCustomDimensions);
}

function _getCustomDimensions(incomingCustomDimensions) {
    var currentCustomDimensions = customDimensions;
    if (incomingCustomDimensions) {
        currentCustomDimensions = _assign(currentCustomDimensions, incomingCustomDimensions);
    }
    var keys = Object.keys(currentCustomDimensions);
    var slashStrippedCustomDimensions = {};
    // eslint-disable-next-line prefer-arrow-callback
    keys.forEach(function coerceDimension(element) {
        var key = _stripSlashes(element);
        var value = _stripSlashes(currentCustomDimensions[element]);
        slashStrippedCustomDimensions[key] = value;
    });
    return slashStrippedCustomDimensions;
}

/**
 * Overrides the call to GA with a
 * call to the native iOS and android
 * tracking method
 *
 * @method trackEvent
 * @private
 * @param {object} config
 */
function _trackEvent(config) {
    var category = _stripSlashes(config.category);
    var action = _stripSlashes(config.action);
    var label = _stripSlashes(config.label);
    var value = parseInt(config.value, 10);
    var called;

    var mobNativeAPI = _getMobNativeApi();
    if (mobNativeAPI) {
        if (mobNativeAPI.trackUAWebviewEvent) {
            var nativeCustomDimensions = _getCustomDimensions(config.customDimensions);
            mobNativeAPI.trackUAWebviewEvent(
                category,
                action,
                label,
                value,
                JSON.stringify(nativeCustomDimensions)
            );
            called = true;
        } else if (mobNativeAPI.trackWebviewEvent) {
            mobNativeAPI.trackWebviewEvent(category, action, label, value);
            called = true;
        }
    }

    if (typeof config.hitCallback === 'function') {
        config.hitCallback();
    }

    if (!called) {
        logError('There was no native method for trackEvent');
    }
}

function _trackPageView(config) {
    var page = config.pageURL;
    var called;

    var mobNativeAPI = _getMobNativeApi();
    if (mobNativeAPI) {
        var nativeCustomDimensions = _getCustomDimensions(config.customDimensions);
        if (mobNativeAPI.trackUAPageview) {
            mobNativeAPI.trackUAPageview(page, JSON.stringify(nativeCustomDimensions));
            called = true;
        } else if (mobNativeAPI.trackWebviewPageView) {
            mobNativeAPI.trackWebviewPageView(page);
            called = true;
        }
    }

    if (typeof config.hitCallback === 'function') {
        config.hitCallback();
    }

    if (!called) {
        logError('There was no native method for trackPageView');
    }
}

/**
Removes '/' from analytics params (action, category, label).
Native analytics api uses '/' as a property delimeter. This ensures that arguments
passed to the native analytics api don't get borked due to the presence of a '/'.
See: HDP-5046
@method _stripSlashes
@param {String} field
@return field if it is a string.
@private
*/
function _stripSlashes(field) {
    if (typeof field !== 'string') {
        return undefined;
    }

    return field.replace(/\//g, '-');
}

/**
 * Determines if we should dispatch calls to the native api
 *
 * @method shouldDispatchToNative
 * @private
 */
function shouldDispatchToNative() {
    return !!_getMobNativeApi();
}



//////////////////
// WEBPACK FOOTER
// ./~/@zillow/reg-login/~/@zillow/universal-analytics/lib/native-api.js
// module id = 540
// module chunks = 0